import { IPage, ISearchPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";

//详情
export interface IRoutineDetail {
    id?: string,
    prefix?: string,
    shopId?: string,
    shopCode?: string,
    shopName?: string,
    branch?: string,
    ver?: string,
    enable?: string,
    orgCode?: string,
    orgName?: string,
    contact?: string,
    phone?: string,
    address?: string,
    status?: number | boolean,
    sourceApp?: string,
    categoryName?:string,
    typeCode?:string,
    typeName?:string,
    suffixNum?: number,
    settingType? : string,
    isYear?: number,
    isMonth?: number,
    isDate?: number,
    style? : string,
    note? : string,
    orderNum?: number,
    traceId?: string,
    deleteFlag?: number,
    createTime? : string,
    updateTime? : string,
    createUser? : string,
    updateUser? : string,
    [key: string]: any
}
//新增
export interface IRoutineInsert {
    "prefix"?:string,   // "ad reprehenderit magna in",
    "suffixNum"?:number,   // 22,
    "settingType"?:string,   // "CALCULATE",
    "isYear"?:number,   // 55,
    "isMonth"?:number,   // 59,
    "isDate"?:number,   // 20180911,
    "note"?:string,   // "veniam sint laborum tempor",
    "style"?:string,   // "incididunt"
}

//编辑
export interface IRoutineUpdate extends IRoutineInsert {
    id?: string,
}
//搜索条件
export interface IRoutineSearchFields {
    startTime?:string
    endTime?:string
    [key:string]:any
}

export interface IRoutineSearch
    extends IRoutineSearchFields, ISearchPage {
    shopId?: string
    shopCode?: string
}

export interface IpositionSearch
    extends IRoutineSearchFields, ISearchPage {
}



class RoutineService {
    async page(searchVo: IRoutineSearch, config: object = {}) {
        const apiUrl = "/threeInspection/base/line/list";
        return await httpRequest.post<IPage<IRoutineDetail>>(apiUrl, searchVo, config);
    }     
    async insert(searchVo: IRoutineSearchFields) {
        const apiUrl = "/threeInspection/base/line/insert";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }    
    async edit(searchVo: IRoutineSearchFields) {
        const apiUrl = "/threeInspection/base/line/update";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }   
    async onDelete(searchVo: IRoutineSearchFields) {
        const apiUrl = "/threeInspection/base/line/delete";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }  
    async one(searchVo: IRoutineSearchFields) {
        const apiUrl = "/threeInspection/ciOrder/page";
        return await httpRequest.post<IPage<IRoutineDetail>>(apiUrl, searchVo);
    }    
    async orderLogs(searchVo: IRoutineSearchFields) {
        const apiUrl = "/threeInspection/ciOrder/progress_log/list";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }   
    async getRoutineImg(updateVo: IRoutineUpdate) {
        const apiUrl = "/threeInspection/ciOrder/list_for_group";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async getImageClassifyList(updateVo: IRoutineUpdate) {
        const apiUrl = "/threeInspection/ciOrder/list_for_group";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async getTotal(shopCode: any) {
        const apiUrl = `/threeInspection/ciOrder/accountStatic/${shopCode}`
        return await httpRequest.get<any>(apiUrl)
    }
    //导出
    async export(searchVo: any) {
        const appPageUrl = '/threeInspection/ciOrder/pageDetails/export'
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 })
    }
}

export const routineService = new RoutineService();
